import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Reorder,
  Resize,
  Sort,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { useEffect, useState } from 'react';
import { BiX } from 'react-icons/bi';
import { BsCheck2 } from 'react-icons/bs';
import {all_information, GetErpTypeFromConfig, loadingShow} from '../App';
import {
  AddGlobalFilter,
  DeleteGlobalFilter,
  EditGlobalFilter,
  getGlobalFilter,
} from '../services/GlobalFilter/GlobalFilterServices';
import Message from '../utils/Message/Message';
import { SyncFullMexGlobalFilterOperations } from '../services/MexServices/GlobalFilter/MexGlobalFilterService';
import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';

let dropDownListObjectColor: ColorPickerComponent = new ColorPickerComponent(
  {}
);
var gridWorkordersFilterObj: GridComponent = new GridComponent({});
let isAdd: boolean = false;
let id: number = 0;
let isRenderFinish: boolean = false;
var dropdownnEnabled: SwitchComponent = new SwitchComponent({});
interface IProps {
  query: string;
  columns: Array<any>;
}
const GlobalFilterComponent = ({ columns, query }: IProps) => {
  const ERP_TYPE = GetErpTypeFromConfig();
  const erpTypeName = 'MEX';
  const validationRule: Object = { required: true };
  const [datasource, setDatasource] = useState([]);
  const FilterOptions: FilterSettingsModel = { type: 'Menu' };
  const editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    showDeleteConfirmDialog: true,
  };
  const pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 50,
    pageCount: 8,
    pageSizes: false,
  };

  const toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    {
      text: 'Sync All',
      tooltipText: 'Sync All',
      id: 'sync_all',
      visible: ERP_TYPE === erpTypeName ? true : false,
    },
    'ColumnChooser',
    'ExcelExport',
  ];
  const toolbarClick = (args: any) => {
    if (args.item.id === 'refresh') {
      console.log('refresh',query);
      getGlobalFilterParam(query);
    }
    if (args.item.id === 'sync_all') {
      console.log('sync_all',args);
      let section = query ? query.split('$')[1] : null;
      loadingShow(true, 'Waiting for sync operations...');
      SyncFullMexGlobalFilterOperations(section)
        .then((result) => {
          if (result.status === 200) {
            loadingShow(false);
            Message.success('Synced successfully...');
            Message.success('Please press the Refresh Button...');
          }
        })
        .catch((err) => {
          loadingShow(false);
          Message.error('Sync failed!!!');
        });
    }
    if (
      gridWorkordersFilterObj &&
      args.item.id === 'gridEventStatus_excelexport'
    ) {
      gridWorkordersFilterObj.excelExport();
    }
  };
  let color: string = '';
  const actionBegin = (args: any) => {
    if (query === 'tradeplanner$type') {
      if (dropDownListObjectColor !== undefined) {
        color = dropDownListObjectColor?.value;
      }
    }
    if (args.action === 'add') {
      isAdd = true;
      addGlobalFilterParamType(args.data);
    } else if (args.action === 'edit') {
      isAdd = false;
      addGlobalFilterParamType(args.data);
    } else if (args.requestType === 'delete') {
      id = args.data[0].id;
      deleteAssetType();
    }
  };
  const deleteAssetType = () => {
    const obj = {
      id: id,
    };
    DeleteGlobalFilter(obj)
      .then(() => {
        loadingShow(false);
        Message.success('Successfully');
        getGlobalFilterParam(query);
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  };
  const getGlobalFilterParam = (query: string) => {
    getGlobalFilter(query)
      .then((res) => {
        loadingShow(false);
        if (isRenderFinish) {
          setDatasource(
            res.data.map((el: any) => {
              return { ...el, name: el.value };
            })
          );
        }
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(err.response.data);
          Message.error(err.response.status);
          Message.error(err.response.headers);
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  };
  const addGlobalFilterParamType = (objCommer: any) => {
    loadingShow(true, 'Adding');
    const obj = {
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      description: objCommer.description,
      value: objCommer.name,
      filter_type: query.split('$')[1],
      filter_section: query.split('$')[0],
      color: dropDownListObjectColor?.value,
      id: objCommer.id,
      isEnabled: dropdownnEnabled.checked,
      alias: objCommer.alias,
      creation_date: new Date(),
      note_id: objCommer.id,
    };

    if (isAdd) {
      AddGlobalFilter(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          getGlobalFilterParam(query);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditGlobalFilter(obj)
        .then(() => {
          loadingShow(false);
          Message.success('Successfully');
          getGlobalFilterParam(query);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  };
  const isTrackExpiryTemplate = (args: any) => {
    let isEnabled = args.isEnabled;
    return (
      <div>
        {isEnabled ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  };
  const isTrackExpiryTemplateEditing = (args: any) => {
    return (
      <SwitchComponent
        checked={args.isEnabled}
        ref={(scope: SwitchComponent) => (dropdownnEnabled = scope)}
      />
    );
  };
  useEffect(() => {
    isRenderFinish = true;
    loadingShow(true, 'process will take some time, please wait...');
    getGlobalFilterParam(query);
    return () => {
      isRenderFinish = false;
    };
  }, []);

  const colorEditTemplate = (args: any) => {
    return (
      <ColorPickerComponent
        value={args.color}
        ref={(scope: any) => (dropDownListObjectColor = scope)}
      />
    );
  };
  const colorTemplate = (args: any) => {
    return <ColorPickerComponent value={args.color} disabled />;
  };
  return (
    <div className='main-content-order-request'>
      <GridComponent
        editSettings={editOptions}
        toolbar={toolbarOptions}
        dataSource={datasource}
        height={'calc(-270px + 100vh)'}
        //   ref={(g: GridComponent) => (gridWorkordersFilterObj = g)}
        filterSettings={FilterOptions}
        allowFiltering={true}
        allowPaging={true}
        pageSettings={pageOptions}
        dataBound={() => {}}
        showColumnMenu={true}
        allowResizing={true}
        allowGrouping={true}
        allowExcelExport={true}
        allowSorting={true}
        groupSettings={{ showGroupedColumn: true }}
        showColumnChooser
        toolbarClick={toolbarClick.bind(this)}
        actionBegin={actionBegin.bind(this)}
        gridLines='Both'
        allowReordering={true}
      >
        <ColumnsDirective>
          {query === 'tradeplanner$type' ? (
            <ColumnDirective
              field='color'
              headerText='#'
              textAlign='Left'
              width={35}
              template={colorTemplate.bind(this)}
              editTemplate={colorEditTemplate.bind(this)}
            />
          ) : (
            <></>
          )}
          {columns.map((el) => {
            return (
              <ColumnDirective
                field={el.field}
                headerText={el.Text.replaceAll('_', ' ')}
                textAlign='Left'
                validationRules={validationRule}
                key={el.field + Math.random()}
              />
            );
          })}
          <ColumnDirective
            field='isEnabled'
            headerText='Enabled'
            width={70}
            template={isTrackExpiryTemplate.bind(this)}
            editTemplate={isTrackExpiryTemplateEditing.bind(this)}
          />
        </ColumnsDirective>
        <Inject
          services={[
            Edit,
            Toolbar,
            Filter,
            Page,
            ColumnChooser,
            ExcelExport,
            ColumnMenu,
            Resize,
            Sort,
            Group,
            Reorder,
          ]}
        />
      </GridComponent>
    </div>
  );
};

export default GlobalFilterComponent;
